<template>
  <div class="Login">
    <div justify="center" align="center">
      <h1 class="text-center text-h4 mt-10">Login</h1>
      <br />
      <v-img
        lazy-src="../assets/Logo_DPEI.png"
        max-height="225"
        max-width="325"
        src="../assets/Logo_DPEI.png"
      ></v-img>
    </div>
    <div class="text-center" justify="center">
      <v-dialog v-model="dialog" width="350">
        <v-card class="text-center">
          <v-card-title class="text-h4 grey justify-center">
            Invalido
          </v-card-title>

          <v-card-text class="text-h6 ">
            Correo o contraseña incorrectos
          </v-card-text>
          <v-card-actions>
            <v-btn
              style=" margin-left: auto; margin-right: auto;"
              color="error"
              outlined
              text
              @click="dialog = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-row style="height: 400px" justify="center" align="center">
      <v-col cols="md-5">
        <v-form v-model="valid">
          <v-text-field
            v-model="email"
            label="E-mail"
            outlined
            :rules="reglas_email"
            required
          >
          </v-text-field>
          <br />
          <v-row class="mx-0 mb-2">
            <v-text-field
              @keydown.enter="login()"
              v-model="password"
              :rules="reglas_contra"
              label="Contraseña"
              outlined
              required
              :type="show_pass ? '' : 'password'"
            >
            </v-text-field>

            <v-btn
              icon
              class="mt-3 ml-n11"
              @mousedown="show_pass = true"
              @mouseup="show_pass = false"
              v-touch="{
                start: () => (show_pass = true),
                end: () => (show_pass = false),
              }"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-row>
          <div class="text-center">
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              v-on:click="login"
              >Login
            </v-btn>

            <a v-on:click="changeURL">Recuperar Contraseña </a>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Login",
  data: () => ({
    valid: true,
    dialog: false,
    show_pass: false,
    password: "",
    email: "",
    reglas_email: [(v) => !!v || "Email es requerido"],
    reglas_contra: [(v) => !!v || "Contraseña es requerida"],
    url: process.env.VUE_APP_ROOT_URL + "user/login",
  }),
  methods: {
    changeURL() {
      window.location.replace("email_code");
    },

    login() {
     
      let vueInstance = this;
      this.email = this.email.toLowerCase();
      this.email = this.email.replace(/\s+/g, "");
      axios({
        method: "POST",
        url: this.url,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          email: this.email,
          password: this.password,
        },
      })
        .then(function(response) {
          var token = `Bearer ${response.data.token}`;
          var session_key = response.data.session_key;
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("session_key", session_key);
          sessionStorage.setItem("lastupdate", "0");

          
          window.location.replace("task_folders");
        })
        .catch(function(error) {
          console.log(error);
          vueInstance.email = "";
          vueInstance.dialog = true;
        });
    },
  },
};
</script>
